<template>
    <kt-panel>
        <div class="row">
            <div class="col-md-9 form-group my-3">
                <label for="message_type">نوع پیام</label>
                <select class="form-control" v-model="type" id="message_type">
                    <option v-for="(value, name, index) in messageType"
                            :key="index" :value="value" v-text="messageTypeStr.get(value)">
                    </option>
                </select>
            </div>
            <div class="col-md-3 my-5">
                <button @click="updateMessage" class="btn btn-success btn-block" id="submit_btn">
                    ثبت
                </button>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12 form-group">
                <textarea
                          v-model="message"
                          class="form-control"
                          rows="10">
                </textarea>
            </div>
        </div>
    </kt-panel>
</template>

<script>
import {editorConfig} from '@/constants/ckeditorConfigs'
import ClassicEditor from "@ckeditor/ckeditor5-editor-classic/src/classiceditor";
import {messageType, messageTypeStr} from "@/constants/telegramMessageType";
import {ApiService} from "@/common/api.service";
import $ from "jquery";
import {KTApp} from '@/plugins/core/app'


export default {
    name: "notificationMessage",
    computed: {
        messageTypeStr() {
            return messageTypeStr
        },
        messageType() {
            return messageType
        }
    },
    data() {
        return {
            data: null,
            editor: ClassicEditor,
            editorData: '',
            message: '',
            editorConfig: editorConfig,
            type: null,
        }
    },
    watch: {
        type(val) {
            this.getMessageData(val)
        }
    },

    methods: {
        getMessageData(type) {
            let btn = $('#submit_btn')
            KTApp.progress(btn)
            this.message = '';
            ApiService.query(`notification-telegram/get-message/${type}`, '')
                .then(({data}) => {
                    KTApp.unprogress(btn)
                    if (data.data)
                        this.message = data.data.payload.message
                }).finally(() => {
                KTApp.unprogress(btn)
            })
        },

        updateMessage() {
            let btn = $('#submit_btn')
            KTApp.progress(btn)
            ApiService.post(`notification-telegram/update-message/${this.type}`, {message: this.message})
                .then(({data}) => {
                    this.toastr.success('بروزرسانی شد🤟')
                    KTApp.unprogress(btn)
                }).finally(() => {
                KTApp.unprogress(btn)
            })
        }
    }
}
</script>

<style>
.ck-editor__editable {
    min-height: 250px !important;
}

</style>